<template>
  <div>
    <section-title class="mt-3" content="Ubicación" has-line />

    <div class="row my-3">
      <info-field
        class="col-4"
        label="Dirección (línea 1):"
        :value="model.studentDetail?.physicalAddress?.address1"
      />
      <info-field
        class="col-4"
        label="Dirección (línea 2):"
        :value="model.studentDetail?.physicalAddress?.address2"
      />
      <info-field class="col-4" label="País:" value="Estados Unidos" />
    </div>

    <div class="row my-3">
      <info-field
        class="col-4"
        label="Estado:"
        :value="model.studentDetail?.physicalAddress?.state"
      />
      <info-field
        class="col-4"
        label="Municipio:"
        :value="model.studentDetail?.mipeStudent?.municipality"
      />
      <info-field
        class="col-4"
        format-type="postal-code"
        label="Código postal:"
        :value="model.studentDetail?.physicalAddress?.zipCode"
      />
    </div>
  </div>
</template>

<script>
import SectionTitle from '@/shared/components/SectionTitle.vue';
import InfoField from './InfoField.vue';

export default {
  name: 'LocationInfoSection',
  components: {
    SectionTitle,
    InfoField,
  },
  props: {
    model: {
      type: Object,
      required: true,
    },
  },
};
</script>
